/* snippet: https://medium.com/@Elijah_Meeks/interactive-applications-with-react-d3-f76f7b3ebc71 */
import React from 'react'
import './styles.scss'
import VideoAutoplay from '../videoAutoplay/'
import renderHTML from 'react-render-html'

export class SectionTitle extends React.Component<Props, State> {
  constructor (props) {
    super(props)

    this.isMobile = window.innerWidth < 600
  }

  render () {
    return (
      <React.Fragment>
        <div className='section-title'>
          <h2>
            <span>{renderHTML(this.props.title)}</span>
          </h2>
          <VideoAutoplay
            mp4={this.props.mp4}
            mp4Mobile={this.props.mp4}
            webm={this.props.webm}
            webmMobile={this.props.webm}
            poster={this.props.poster}
            originals={this.props.originals}
            silent={this.props.silent}
            showControls
          />
        </div>
        {!this.isMobile && <p className='section-lead'>{this.props.lead}</p>}
        {this.isMobile && (
          <div className='ui text container'>
            <p className='section-lead'>{this.props.lead}</p>
          </div>
        )}
      </React.Fragment>
    )
  }
}
